import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';
import { SessionService } from '@src/app/modules/auth';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private readonly ngxPermissionsService = inject(NgxPermissionsService);
  private readonly session = inject(SessionService);

  readonly allowEditing$ = new BehaviorSubject(false);
  readonly allowDeleting$ = new BehaviorSubject(false);

  readonly allowSpecialFieldsViewing$ = new BehaviorSubject(false);
  readonly allowSpecialFieldsEditing$ = new BehaviorSubject(false);
  readonly allowSpecialFieldsForAssociationViewing$ = new BehaviorSubject(false);
  readonly allowSpecialFieldsForAssociationEditing$ = new BehaviorSubject(false);

  readonly allowUsersViewing$ = new BehaviorSubject(false);
  readonly allowUserEditing$ = new BehaviorSubject(false);

  readonly allowChatsCreating$ = new BehaviorSubject(false);
  readonly allowChatsEditing$ = new BehaviorSubject(false);

  readonly allowConfigsViewing$ = new BehaviorSubject(false);

  getPermissions(organisationId?: string) {
    const authUser = this.session.authUser;

    const permissions = this.ngxPermissionsService.getPermissions();
    const permissionsForOrganisation =
      organisationId && authUser?.permissionsForOrganisations
        ? authUser.permissionsForOrganisations[organisationId]
        : [];

    this.allowEditing$.next(
      'organisationEditing' in permissions || permissionsForOrganisation?.includes('onlyYourOrganisationEditing'),
    );

    this.allowDeleting$.next('organisationDeleting' in permissions);

    this.allowSpecialFieldsViewing$.next(
      'organisationSpecialFieldsViewing' in permissions ||
        permissionsForOrganisation?.includes('onlyYourOrganisationSpecialFieldsViewing'),
    );

    this.allowSpecialFieldsEditing$.next(
      'organisationSpecialFieldsEditing' in permissions ||
        permissionsForOrganisation?.includes('onlyYourOrganisationSpecialFieldsEditing'),
    );

    this.allowSpecialFieldsForAssociationViewing$.next(
      'organisationSpecialFieldsForAssociationViewing' in permissions ||
        permissionsForOrganisation?.includes('onlyYourOrganisationSpecialFieldsForAssociationViewing'),
    );

    this.allowSpecialFieldsForAssociationEditing$.next('organisationSpecialFieldsForAssociationEditing' in permissions);

    this.allowUsersViewing$.next(
      'organisationEmployeeViewing' in permissions ||
        !!permissionsForOrganisation?.includes('onlyYourOrganisationEmployeeViewing'),
    );

    this.allowUserEditing$.next(
      'organisationEmployeeCreating' in permissions ||
        permissionsForOrganisation?.includes('onlyYourOrganisationEmployeeCreating'),
    );

    this.allowChatsCreating$.next(
      'organisationChatsCreating' in permissions ||
        permissionsForOrganisation?.includes('onlyYourOrganisationChatsCreating'),
    );

    this.allowChatsEditing$.next(
      'organisationChatsEditing' in permissions ||
        permissionsForOrganisation?.includes('onlyYourOrganisationChatsEditing'),
    );

    this.allowConfigsViewing$.next('organisationConfigsViewing' in permissions);
  }
}
